<template>
  <div>
    <el-dialog title="亲属列表" :visible.sync="isVisible" @close="listDialogClose">
      <el-row>
        <el-col :span="24" class="layout-col">
          <el-card class="table-card" :body-style="{ padding: '0px' }">
            <div slot="header" class="table-card-header">
              <span>亲属列表</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="
                  editFormData = {};
                  editDialogStatus = 1;
                "
                >新增</el-button
              >
            </div>
            <el-table
              :data="tableData"
              border
              highlight-current-row
              style="width: 100%"
              ref="table"
            >
              <el-table-column type="index" width="50" :index="lineNumber">
              </el-table-column>
              <!-- prop  对应列内容的字段名，也可以使用 property 属性 
                 label 属性来定义表格的列名
            -->
              <el-table-column
                v-for="(item, index) in queryListPropertys"
                :key="index"
                :prop="item.propertyName"
                :label="item.chineseName"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <i
                    class="el-icon-search"
                    title="查看"
                    @click="
                      editFormData = scope.row;
                      detailDialogStatus = 1;
                    "
                  ></i>
                  <i
                    class="el-icon-edit"
                    title="修改"
                    @click="
                      editData = scope.row;
                      DialogStatus = 2;
                    "
                  ></i>
                  <i
                    class="el-icon-delete"
                    title="删除"
                    @click="deleteTableData(scope.row)"
                  ></i>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              :total="totalElements"
              @current-change="tablePaging"
            >
            </el-pagination>
          </el-card>
        </el-col>
        <el-col :span="12" class="layout-col"> </el-col>
      </el-row>
    </el-dialog>
    <!-- 添加模态框 -->
    <el-dialog
      title=""
      :visible="true"
      @close="editDialogClose"
      width="75%"
      v-if="editDialogStatus != 0"
    >
      <!-- <edit-form-builder :entityPropertys="entityPropertys" :formData="editFormData" :colsOfRow="editFormColsOfRow" :formStatus="editDialogStatus"></edit-form-builder> -->
      <el-form ref="xzyh" :model="form" :rules="insertRules" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="亲属姓名">
              <el-input v-model="form.xm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="亲属关系">
              <el-input v-model="form.qsgx"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="婚姻状态">
              <el-select v-model="form.hyzt" placeholder="请选择婚姻状态">
                <el-option label="未婚" value="1"></el-option>
                <el-option label="已婚" value="2"></el-option>
                <el-option label="离异" value="3"></el-option>
                <el-option label="丧偶" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="性别">
              <el-select v-model="form.xb" placeholder="请选择性别">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item label="联系方式">
                <el-input v-model="form.lxfs"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工作单位">
                <el-input v-model="form.gzdw"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
         <el-row>
            <el-col :span="8">
              <el-form-item label="居住地">
                <el-input v-model="form.jzd"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="户籍地">
                <el-input v-model="form.hjd"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证" prop="sfzhm">
                <el-input
                  placeholder="身份证号"
                  v-model="form.sfzhm"
                >
                </el-input>
              </el-form-item>
            </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogStatus = 0">取 消</el-button>
        <el-button type="primary" @click="saveEditFormData">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看模态框 -->
    <el-dialog
      title=""
      :visible="true"
      @close="detailDialogClose"
      width="75%"
      v-if="detailDialogStatus != 0"
    >
      <!-- <detail-table-builder :entityPropertys="entityPropertys" :rowData="editFormData" :colsOfRow="detailTableColsOfRow"></detail-table-builder> -->
      <el-form ref="form" :model="editFormData" :disabled='edit' label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="亲属姓名">
              <el-input v-model="editFormData.xm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="亲属关系">
              <el-input v-model="editFormData.qsgx"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="婚姻状态">
              <el-input :value="editFormData.hyzt == 1 ? '未婚' : editFormData.hyzt == 2 ? '已婚' : editFormData.hyzt == 3 ? '离异' :'丧偶'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="性别">
              <el-input :value="editFormData.xb == 1 ? '男' : '女'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item label="联系方式">
                <el-input v-model="editFormData.lxfs"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工作单位">
                <el-input v-model="editFormData.gzdw"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
         <el-row>
            <el-col :span="8">
              <el-form-item label="居住地">
                <el-input v-model="editFormData.jzd"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="户籍地">
                <el-input v-model="editFormData.hjd"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证">
                <el-input
                  placeholder="身份证号"
                  v-model="editFormData.sfzhm"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <div v-if="edit" slot="footer" class="dialog-footer">
              <el-button @click="editDialogStatus = 0">取 消</el-button>
              <el-button type="primary" @click="saveEditFormData(editFormData)">确 定</el-button>
            </div>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 修改模态框 -->
    <el-dialog
      title=""
      :visible="true"
      @close="DialogClose"
      width="75%"
      v-if="DialogStatus !=0"
    >
      <!-- <detail-table-builder :entityPropertys="entityPropertys" :rowData="editFormData" :colsOfRow="detailTableColsOfRow"></detail-table-builder> -->
      <el-form ref="xzyh" :rules="insertRules" :model="editData" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="亲属姓名">
              <el-input v-model="editData.xm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="亲属关系">
              <el-input v-model="editData.qsgx"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="婚姻状态">
              <el-select v-model="editData.hyzt" placeholder="请选择婚姻状态">
                <el-option label="未婚" value="1"></el-option>
                <el-option label="已婚" value="2"></el-option>
                <el-option label="离异" value="3"></el-option>
                <el-option label="丧偶" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="性别">
              <el-select v-model="editData.xb" placeholder="请选择性别">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item label="联系方式">
                <el-input v-model="editData.lxfs"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工作单位">
                <el-input v-model="editData.gzdw"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
         <el-row>
            <el-col :span="8">
              <el-form-item label="居住地">
                <el-input v-model="editData.jzd"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="户籍地">
                <el-input v-model="editData.hjd"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证" prop="sfzhm">
                <el-input
                  placeholder="身份证号"
                  v-model="editData.sfzhm"
                >
                </el-input>
              </el-form-item>
            </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="DialogStatus = 0">取 消</el-button>
          <el-button type="primary" @click="updateEditFormData">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "table-list",
  data() {
    return {
      xzyh: {
        // 新增用户信息
        username: "", // 用户名
        xm: "", // 姓名
        xb: "", // 性别
        sfzhm: "", // 身份证号码
        zw: "", //职位
      },
      edit:true,
      yhid:'',
      form: {
        userid:this.yhid,
        xm:'',
        xb:'',
        hyzt:'',
        hjd:'',
        jzd:'',
        sfzhm:'',
        lxfs:'',
        gzdw:'',
        qsgx:'',
        ljsc:''
      },
      isVisible: true,
      //列表数据
      tableData: [],
      // dictionaryId: null,
      // searchString: null,
      totalElements: 0,
      pageNumber: 0,
      detailDialogStatus: 0, //控制模态框
      editFormColsOfRow: 2,
      editDialogStatus: 0,
      DialogStatus:0,
      editFormData: {},
      editData: {},
      detailTableColsOfRow: 2,
      //表单数据
      // entityPropertys: [],
      //列表列名和键名
      queryListPropertys: [
        {
          propertyName: "xm",
          chineseName: "亲属名称",
        },
        {
          propertyName: "lxfs",
          chineseName: "联系方式",
        },
        {
          propertyName: "qsgx",
          chineseName: "亲属关系",
        },
        {
          propertyName: "gzdw",
          chineseName: "工作单位",
        },
      ],
      insertRules: {
        xm: [
          {
            required: true,
            message: "请填写姓名",
            trigger: ["blur", "change"],
          },
        ],
        // xb: [{
        // 	required: true,
        // 	message: '请选择性别',
        // 	trigger: ['blur', 'change']
        // }],
        sfzhm: [
          {
            required: true,
            message: "请填写身份证号",
            trigger: ["blur", "change"],
          },
          { validator: this.isCardID, trigger: ["blur", "change"] },
        ],
      },
    };
  },
  //  watch:{
  //     yhid: function(newVal,oldVal){
  //       this.yhid = newVal;  //newVal即是chartData
  //       this.fetchTableData()
  //   }
  // },
  methods: {
    //获取用户亲属信息
    fetchTableData(id) {
      if(id){
        this.yhid = id
      }
      request({
        url: "/bjba/yhgl/getQsxx",
        method: "get",
        params: {
          page: this.pageNumber,
          size: 10,
          userid:this.yhid
        },
      })
        .then((response) => {
          const data = response.data;
          this.tableData = data.content;
          this.totalElements = data.totalElements;
          // this.$nextTick(() => {
          //   if (this.tableData.length > 0) {
          //     this.$refs.table.setCurrentRow(this.tableData[0])
          //   }
          // })
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //保存用户信息
    saveEditFormData() {
      let formData ={}
      this.$set(this.form,'ljsc','0')
      this.$set(this.form,'userid',this.yhid)
      formData = this.form 
      console.log(this.form);
      this.$refs["xzyh"].validate((valid) => {
        if (!valid){
          console.log('error submit!!');
          return false;
        }
        request({ 
          url: "/bjba/yhgl/xzqsxx",
          method: "post",
          data: formData,
        })
          .then((response) => {
            const data = response.data
            if (this.editDialogStatus === 1) {
              this.tableData.unshift(data); //将元素添加
              this.totalElements = this.totalElements + 1;
              this.$refs.table.setCurrentRow();
              // this.$nextTick(() => {
              //   this.$refs.table.setCurrentRow(this.tableData[0]);
              // });
            } else {
              this.tableData = this.tableData.map((item) => {
                return item.id === data.id ? data : item;
              });
            }
            this.form = {}
            this.editDialogStatus = 0;
            this.$message("操作成功");
          })
          .catch((error) => {
            console.log(error);
            this.$message("操作失败");
          });
      });
      
    },
    //保存用户信息
    updateEditFormData() {
      let formData ={}
      this.$set(this.editData,'ljsc','0')
      formData = this.editData 
      this.$refs["xzyh"].validate((valid) => {
        if (!valid){
          console.log('error submit!!');
          return false;
        }
      request({ 
        url: "/bjba/yhgl/xzqsxx",
        method: "post",
        data: formData,
      })
        .then((response) => {
          this.fetchTableData()
          this.DialogStatus = 0;
          this.$message("修改成功");
        })
        .catch((error) => {
          console.log(error);
          this.$message("操作失败");
        });
      });
    },
    //删除亲属数据
    deleteTableData(row) {
      console.log(row);
      let data = row;
      this.$confirm("确定删除【" + row.xm + "】吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$set(data, "ljsc", "1");
          request({
            url: "/bjba/yhgl/deleteQsxx",
            method: "PUT",
            data: data,
          })
            .then((response) => {
              this.fetchTableData();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch((error) => {
              console.log(error);
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            });
        })
        .catch(() => {});
    },
    listDialogClose() {
      let close = false;
      console.log("-------------");
      this.$emit("closepop", close);
    },
    editDialogClose() {
      this.editDialogStatus = 0;
    },

    detailDialogClose() {
      this.detailDialogStatus = 0;
    },

    DialogClose() {
      this.DialogStatus = 0;
    },

    lineNumber(index) {
      return this.pageNumber * 10 + index + 1;
    },

    tablePaging(pageNumber) {
      this.pageNumber = pageNumber - 1;
      this.fetchTableData();
    },
    search() {
      this.fetchTableData();
    },
    getNowFormatDate() {
      var myDate = new Date();
      var year = myDate.getFullYear();
      var month = myDate.getMonth() + 1;
      var date = myDate.getDate();
      var h = myDate.getHours();
      var m = myDate.getMinutes();
      var s = myDate.getSeconds();
      var now =
        year +
        "-" +
        (month < 10 ? "0" : "") +
        month +
        "-" +
        (date < 10 ? "0" : "") +
        date +
        " " +
        (h < 10 ? "0" : "") +
        h +
        ":" +
        (m < 10 ? "0" : "") +
        m +
        ":" +
        (s < 10 ? "0" : "") +
        s;
      return now;
    },
    isCardID(rule, value, callback) {
      this.$set(this.xzyh, "csrq", "");
      console.log(value);
      if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        callback(new Error("身份证长度或格式错误"));
        return;
      }
      //身份证城市
      var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外",
      };
      if (!aCity[parseInt(value.substr(0, 2))]) {
        callback(new Error("身份证地区非法"));
        return;
      }

      // 出生日期验证
      var sBirthday = (
          value.substr(6, 4) +
          "-" +
          Number(value.substr(10, 2)) +
          "-" +
          Number(value.substr(12, 2))
        ).replace(/-/g, "/"),
        d = new Date(sBirthday);
      if (
        sBirthday !=
        d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
      ) {
        callback(new Error("身份证上的出生日期非法"));
        return;
      }

      // 身份证号码校验
      var sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432";
      for (var i = 0; i < value.length - 1; i++) {
        sum += value[i] * weights[i];
      }
      var last = codes[sum % 11]; //计算出来的最后一位身份证号码
      if (value[value.length - 1].toUpperCase() != last) {
        callback(new Error("身份证号非法"));
        return;
      }

      callback();
    }
  },
};
</script>
<style scoped>
.layout-col {
  text-align: center;
}
.search-input {
  width: 80%;
  margin: 5px;
}

.table-card-header {
  text-align: left;
}
.dialog-footer {
  text-align: center;
}
.el-icon-search,
.el-icon-edit,
.el-icon-delete {
  cursor: pointer;
}
</style>
